module.exports = __webpack_public_path__ + "static/dagny-bold-2ff689cf58b6c8b11bbfa260cd85a4e3.woff";